import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { xtractAPI } from 'actions/apiActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useWorkflow, useContext } from 'hooks/useURL'
const FavoriteButton = ({ name: itemName, type, canFavorite }) => {
  const [favoriteId, setFavoriteId] = useState()
  // is favorite isn't really needed but by using it to determine the icon and updating it in
  // real time the ui feels more responsive because it responds to the click rather than
  // waiting on the api to respond
  const [isFavorite, setIsFavorite] = useState()
  const dispatch = useDispatch()
  const userId = useSelector(state => state.auth.user_id)
  const favorites = useSelector(state => state.userConfig.favorites)
  const { workflow } = useWorkflow()
  const context = useContext()

  useEffect(() => {
    const config = (favorites || []).find(fav => fav.value === itemName && fav.name === `${context}-${type}`)
    if (config && !favoriteId) {
      setFavoriteId(config.user_config_id)
    }
    if (config && !isFavorite) {
      setIsFavorite(true)
    } else if (!config && isFavorite) {
      setIsFavorite(false)
    }
  }, [favorites])

  const toggleUserFavorite = useCallback(() => {
    if (favoriteId) {
      setIsFavorite(false)
      dispatch(xtractAPI(`user/config/${favoriteId}`, 'delete'))
    } else {
      setIsFavorite(true)
      const newFav = {
        user_id: userId,
        section: 'favorite',
        name: `${context}-${type}`,
        value: itemName
      }
      dispatch(xtractAPI('user/config', 'create', newFav))
    }
  }, [favoriteId])

  const favIconFamily = isFavorite ? 'fas' : 'fal'

  if (canFavorite === false || workflow != null) {
    return <div className="favorite-window"/>
  } else {
    return (
      <div className="favorite-window" onClick={toggleUserFavorite}>
        <FontAwesomeIcon
          icon={[favIconFamily, 'star']}
          aria-label={'favorite window icon'}
          className="favorite-button"
        />
      </div>
    )
  }
}

export default FavoriteButton
